"use client";

import React from "react";
import Image from "next/image";
import { useTranslations } from "next-intl";

export default function CardsSection() {
    const t = useTranslations('home.agent.cards');

    type CardKey = 'operator' | 'score' | 'replies' | 'followUps' | 'monitor' | 'takeControl';
    type CardConfig = {
        key: CardKey;
        image: string;
    };

    const CARDS: CardConfig[] = [
        { key: 'operator', image: '/features/operator.avif' },
        { key: 'score', image: '/features/score.avif' },
        { key: 'replies', image: '/features/replies.avif' },
        // second row
        { key: 'followUps', image: '/features/track.avif' },
        { key: 'monitor', image: '/features/follow-ups.avif' },
        { key: 'takeControl', image: '/features/generate.avif' },
    ];

    return (
        <section className="undetectable relative z-10 overflow-hidden pt-[113px] md:pt-[152px] lg:pt-[200px] xl:pt-[217px]">
            <div className="mx-auto px-5 md:max-w-[768px] md:px-8 lg:max-w-[1024px] xl:max-w-[1280px] xl:px-8 2xl:max-w-[1408px]">
                <div className="2xl:pl-16">
                    <span className="block text-18 leading-snug font-medium tracking-tight text-theos-500 lg:text-24">
                        {t('kicker')}
                    </span>
                    <h2 className="font-title mt-3 text-24 leading-tight font-medium tracking-4 md:mt-3.5 md:text-28 lg:mt-4.5 lg:text-36 xl:text-40">
                        {t('title')}
                    </h2>
                </div>
                <div className="relative mt-10 grid grid-cols-1 gap-10 md:mt-11 md:grid-cols-2 md:gap-x-7 md:gap-y-10 lg:mt-12 lg:grid-cols-3 lg:gap-x-6 2xl:mt-14 2xl:gap-x-[32px]">
                    {CARDS.map((card) => (
                        <div key={card.key}>
                            <div className="card-styles shadow-md">
                                <div className="absolute inset-0 md:inset-0 xl:inset-0  rounded-[12px] md:rounded-[16px] xl:rounded-[20px] overflow-hidden">
                                    <Image
                                        src={card.image}
                                        alt={t(`cards.${card.key}.title`)}
                                        fill
                                        className="absolute inset-0 h-full w-full object-cover"
                                        sizes="(min-width: 1280px) 384px, (min-width: 1024px) 33vw, (min-width: 768px) 50vw, 100vw"
                                        quality={100}
                                        priority={false}
                                    />
                                </div>
                            </div>
                            <div className="text-base max-w-[600px] mx-auto sm:text-18 2xl:mt-[26px] xl:mt-[18px] mt-[19px] md:mt-5 xl:text-20 tracking-tight leading-snug text-gray-40">
                                <p>
                                    <strong className="text-gray-20 mr-1 font-medium">
                                        {t(`cards.${card.key}.title`)}
                                    </strong>
                                    {t(`cards.${card.key}.body`)}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
                <div aria-hidden="true" className="mt-10 mb-8 h-px w-full bg-gray-90 md:mt-11 md:mb-8 lg:mt-14 lg:mb-9 xl:mt-16 xl:mb-10">
                </div>

            </div>
        </section>
    );
}